module.exports = __webpack_public_path__ + "media/images/pic/labels/a1_1b-4ce55d17ce15fc2b159fe970e3efe48d.png";